import { render } from "./XTimerComponent.vue?vue&type=template&id=313b5c94&scoped=true"
import script from "./XTimerComponent.vue?vue&type=script&lang=js"
export * from "./XTimerComponent.vue?vue&type=script&lang=js"

import "./XTimerComponent.vue?vue&type=style&index=0&id=313b5c94&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313b5c94"]])

export default __exports__